import { DecimalPipe, I18nPluralPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ideal-product-container-quantity',
  imports: [DecimalPipe, I18nPluralPipe],
  templateUrl: './product-container-quantity.component.html',
  styleUrl: './product-container-quantity.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductContainerQuantityComponent {
  public readonly quantity = input.required<number>();
  public readonly unitLabel = input.required<Record<string, string>>();
  public readonly containerUnitLabel = input<string>($localize`:@@product.container-quantity.container.default-label:box`);
}
